import { Card, Skeleton, Space, Button, Input, Table } from 'antd';
import { Plus, Search } from 'lucide-react';

const UserManagementSkeleton = () => {
  // Mock columns for the skeleton table
  const columns = [
    { title: 'Employee ID', dataIndex: 'employeeId', key: 'employeeId' },
    { title: 'Name', dataIndex: 'name', key: 'name' },
    { title: 'Email', dataIndex: 'email', key: 'email' },
    { title: 'Role', dataIndex: 'role', key: 'role' },
    { title: 'Actions', dataIndex: 'actions', key: 'actions' },
  ];

  // Create empty data array for skeleton rows
  const skeletonData = Array(5)
    .fill(null)
    .map((_, index) => ({
      key: index,
      employeeId: <Skeleton.Input active size="small" style={{ width: 80 }} />,
      name: <Skeleton.Input active size="small" style={{ width: 120 }} />,
      email: <Skeleton.Input active size="small" style={{ width: 150 }} />,
      role: <Skeleton.Input active size="small" style={{ width: 100 }} />,
      actions: (
        <Space>
          <Skeleton.Button active size="small" shape="circle" />
          <Skeleton.Button active size="small" shape="circle" />
        </Space>
      ),
    }));

  return (
    <Card>
      <div className="flex flex-col md:flex-row md:justify-between md:items-center mb-4">
        <div className="w-full md:w-1/5 mb-4 md:mb-0">
          <Input
            placeholder="Search users..."
            prefix={<Search className="text-gray-400" />}
            disabled
          />
        </div>
        <Button type="primary" icon={<Plus />} disabled>
          Create New User
        </Button>
      </div>

      <Table
        dataSource={skeletonData}
        columns={columns}
        pagination={{ pageSize: 15 }}
        loading={false}
      />
    </Card>
  );
};

export default UserManagementSkeleton;
